import { getSantriPhoto } from '../lib/api';

interface Santri {
  id: string;
  nama: string;
  nis?: string;
  kelompok: {
    id: string;
    nama: string;
    desa: { id: string; nama: string };
  };
  fotoKey?: string;
  createdAt: string;
}

interface SantriTableProps {
  santri: Santri[];
  onDelete: (id: string) => void;
  canEdit: boolean;
}

export default function SantriTable({ santri, onDelete, canEdit }: SantriTableProps) {
  if (santri.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <p>Belum ada data santri</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="table">
        <thead>
          <tr>
            <th>Foto</th>
            <th>Nama</th>
            <th>NIS</th>
            <th>Kelompok</th>
            <th>Desa</th>
            <th>Wali</th>
            <th>Telepon</th>
            {canEdit && <th className="text-right">Aksi</th>}
          </tr>
        </thead>
        <tbody>
          {santri.map((s) => (
            <tr key={s.id}>
              <td>
                <div className="w-10 h-10 rounded-full bg-gray-700 overflow-hidden">
                  {s.fotoKey ? (
                    <img
                      src={getSantriPhoto(s.id)}
                      alt={s.nama}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                      <span className="text-sm">👤</span>
                    </div>
                  )}
                </div>
              </td>
              <td className="font-medium text-white">{s.nama}</td>
              <td>{s.nis || '-'}</td>
              <td>
                <span className="badge badge-desa">{s.kelompok.nama}</span>
              </td>
              <td className="text-gray-400">{s.kelompok.desa.nama}</td>
              <td className="text-gray-400">{s.namaWali || '-'}</td>
              <td className="text-gray-400">{s.noTeleponWali || '-'}</td>
              {canEdit && (
                <td className="text-right">
                  <button
                    onClick={() => onDelete(s.id)}
                    className="text-red-400 hover:text-red-300 text-sm"
                  >
                    Hapus
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
